/**
 * Field note correction types — must match backend FIELD_NOTE_CORRECTION_TYPES
 * in backend/app/schemas.py (API rejects other values on POST /field-notes).
 */
export const FIELD_NOTE_CORRECTION_TYPES = [
  "Missing clock-in",
  "Missing clock-out",
  "Incorrect hours recorded",
  "Missing Meal/break",
  "Job Location correction",
  "Cost Code Correction",
  "Travel Note",
  "Other (requires explanation)",
] as const;

export type FieldNoteCorrectionType = (typeof FIELD_NOTE_CORRECTION_TYPES)[number];

/** Type of Correction + Reason for Correction are required; Additional Note is optional. */
export function isFieldNoteFormValid(form: {
  correction_type: string;
  reason_for_correction: string;
}): boolean {
  return Boolean(form.correction_type.trim() && form.reason_for_correction.trim());
}
